<template>
    <label :class="value==='1'?'y':'n'">
      {{getText()}}
    </label>
</template>

<script>
  export default {
    name: 'Yn',
    props:{
      value:{
        type:String,
        default:''
      }
    },
    methods:{
      getText(){
        return this.value==='1'?'是':'否'
      }
    }
  }
</script>

<style scoped>
  .y{
    color: green;
  }
  .n{
    color: red;
  }
</style>